import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'submit-buttons-section',
  templateUrl: './submit-buttons-section.component.html',
  styleUrls: ['./submit-buttons-section.component.scss']
})
export class SubmitButtonsSectionComponent implements OnInit {
  @Input() showOnlySaveButton: boolean;
  @Input() saveButtonText: string;
  @Input() addMoreButtonText: string;
  @Input() disabled: boolean;
  @Input() showAsSticky: boolean;
  @Input() moveStickyBottomButtons: boolean;

  @Output() onSubmit = new EventEmitter<{ goNext: boolean; addMore: boolean }>();

  constructor() {
  }

  ngOnInit() {
  }

  public submit(goNext: boolean, addMore: boolean) {
    this.onSubmit.emit({ goNext, addMore });
  }
}
